import React, { useCallback, useMemo, useState } from 'react';

import Button from './components/Button';
import Modal from './components/Modal';
import { HelpData } from './types';
import * as S from './styles';
import { sendHelpData, SUBJECT_OPTIONS } from './service';
import { useLocation } from 'react-router';
import Toast from 'components/Shared/Toast';

const HelpUser = () => {
  const { pathname } = useLocation();
  const [hiddenButton, setHiddenButon] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const eventId = useMemo(() => pathname?.split('/')[2], [pathname]);

  const handleSubmitData = useCallback(
    (helpData: HelpData) => {
      if (!eventId) {
        Toast.error('Erro de comunicação. Recarregue a página');
        return;
      }

      setLoadingModal(true);
      sendHelpData(helpData, eventId).subscribe({
        next: () => {
          setLoadingModal(false);
          handleOpenModal();
          Toast.show('Sua mensagem foi enviada com sucesso');
        },
        error: () => {
          setLoadingModal(false);
          Toast.error('Erro de comunicação. Recarregue a página');
        },
      });
    },
    [eventId],
  );

  const handleOpenModal = () => {
    setHiddenButon(prevState => !prevState);
  };

  return (
    <S.Wrapper>
      <Button hidden={hiddenButton || !eventId} onClick={handleOpenModal} />
      <Modal
        key={`modal-${eventId}-${String(hiddenButton)}`}
        onSubmit={handleSubmitData}
        handleClose={handleOpenModal}
        open={hiddenButton}
        loading={loadingModal}
        subjects={SUBJECT_OPTIONS}
      />
    </S.Wrapper>
  );
};

export default HelpUser;
